import { capitalize } from 'lodash';

const internalToDisplayName: Record<string, string> = {
  SAStarter: 'Starter',
  SAPro: 'Pro',
  SAScale: 'Scale',
};

export const PRO_PLAN_MONTHLY = 'StreamAlive Pro Plan Monthly';
export const PRO_PLAN_ANNUAL = 'StreamAlive Pro Plan Annual';

export const getFormattedPlanName = (plan: string) => {
  if (!plan) return '';
  if (plan === 'Free Plan') return 'Free Plan';
  if (plan === PRO_PLAN_MONTHLY) return 'Pro (monthly)';
  if (plan === PRO_PLAN_ANNUAL) return 'Pro (annually)';
  if (plan === 'StreamAlive 4 Sessions Package') return 'Session pack';
  const [planName, frequency] = plan.split('-');
  const interval = frequency?.toLowerCase() === 'yearly' ? 'annually' : 'monthly';
  const displayName = internalToDisplayName[planName] ?? capitalize(planName.toLowerCase().replace('plan', ''));

  if (plan === 'SAPro-Trial') {
    return 'Pro Trial';
  }

  return `${displayName} (${interval})`;
};

export const planNameToSlug = (plan: string) => {
  // The Oct 2026 plan slugs are the kebab-cased names, e.g. streamalive-pro-plan-annual
  if (plan.startsWith('StreamAlive ')) return plan.toLowerCase().replace(/\s+/g, '-');
  return plan.replace(/^SA/, 'sa').toLowerCase();
};

export const convertToK = (num: number) => {
  if (num >= 1000) {
    return `${Math.round(num / 1000)}K`;
  }
  return num;
};
